import React from 'react';
import ReactDOM from 'react-dom';

import ProductGroupsSettingsComponent from '../components/ProductGroupsSettingsComponent';
import ProductGroupsSettingsContext from '../context/ProductGroupsSettingsContext';

const initialized_for_product = {};

export default class ProductgroupEditController {
	initOnProductEditPage(state, mount_root_id, product_controller) {
		const mount_root = document.getElementById(mount_root_id);
		if (!mount_root) {
			console.warn('нет элемента с id [' + mount_root_id + ']');

			return;
		}

		const context = new ProductGroupsSettingsContext(state);

		this._renderForm(context, mount_root);
		// this._initSaveHandler(product.id, mount_root);
		this._initTabSaveHandler(product_controller, context);
	}

	_renderForm(context, mount_root) {
		ReactDOM.render(
			<ProductGroupsSettingsComponent context={context} />,
			mount_root
		);
	}

	/**
	 * @param product_controller
	 * @param {ProductGroupsSettingsContext} context
	 * @private
	 */
	_initTabSaveHandler(product_controller, context) {
		const save_method_name = 'editTabGroupsFormSave';

		const saveHandler = async () => {
			const success = await context.save();

			return success;
		};

		product_controller[save_method_name] = saveHandler.bind(product_controller);
	}
}
